import React from "react";
import styled from "styled-components";
import Home from "./Samples/Home";
import PreviewWrapper from "./PreviewWrapper";
import Header from "./Samples/Header";
import Footer from "./Samples/Footer";
import Navigationbar from "./Samples/NavigationBar";
import Message from "./Samples/Message";
import ErrorMessage from "./Samples/ErrorMessage";
import WarningMessage from "./Samples/WarningMessage";
import SecondaryButton from "./Samples/SecondaryButton";
import TextLink from "./Samples/TextLink";

export const previewNavTabsId = "preview-nav-tabs";

const BackgroundDiv = styled.div`
  background-color: ${(props) => props.theme.palette.body?.backgroundcolor};
`;

const PreviewWindow = () => {
  return (
    <PreviewWrapper>
      <BackgroundDiv>
        <Header />
        <Navigationbar />
        <Message />
        <ErrorMessage />
        <WarningMessage />
        <TextLink />
        <SecondaryButton />
        <Home />
        <Footer />
      </BackgroundDiv>
    </PreviewWrapper>
  );
};

export default PreviewWindow;
